import { createContext, useContext } from 'react';

import { type WizardContextType } from './types';

const WizardContext = createContext<WizardContextType | null>(null);

export const useWizardContext = <T = Record<string, unknown>,>(): WizardContextType<T> => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizardContext must be used within a WizardDialog');
  }
  return context as WizardContextType<T>;
};

export default WizardContext;
